import { Navigate } from "react-router-dom";

type Props = {
  children: JSX.Element;
  user: unknown | undefined;
};

export const PublicRoute = ({ user, children }: Props): JSX.Element => {
  if (
    user != null &&
    typeof user === "object" &&
    Object.keys(user).length !== 0
  ) {
    if (
      "role" in user &&
      (user.role === "dealer-employee" || user.role === "super-admin")
    ) {
      return <Navigate to="/dashboard" replace />;
    }

    return <Navigate to="/tire-sets" replace />;
  }

  return children;
};
